<div class="col-md-12 float-left customersearch-forms login-forms p-0 mb-4">
  <form [formGroup]="findMyContactSearchForm" (ngSubmit)="submitForm()">
    <div class="form-group col-lg-6 pl-0 multi-select-styles mt-4">
      <!--<ng-select *ngIf="!hasContext" [items]="customersDataList$ | async" [clearSearchOnAdd]="true"
      [closeOnSelect]="false" labelForId="state" [multiple]="true"
      [placeholder]="'orderHistorySearchForm.label.accountId' | cxTranslate" clearAllText="Clear"
      formControlName="accountNumber" [bindLabel]="'Text'" [virtualScroll]="true"on>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <div class="row">
          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
            [ngModelOptions]="{standalone: true}" />
            {{item['Text']}}
          </div>
        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items">
          <div class="ng-value" *ngFor="let item of items | slice:0:1">
            {{item['Text']}}
          </div>
          <div class="ng-value" *ngIf="items.length > 1">
            <span class="ng-value-label">{{items.length - 1}} more...</span>
          </div>
        </ng-template>
      </ng-select>-->
      @if (hasContext) {
        <input type="text" class="form-control w-100"
          [placeholder]="'orderHistorySearchForm.label.accountId' | cxTranslate" formControlName="accountNumber" />
      }
      <span class="highlight"></span>
      <label class="text-muted">{{ 'orderHistorySearchForm.label.accountId' | cxTranslate }}</label>
    </div>
    <div class="form-group col-lg-6 pl-0 float-left mb-3 mt-3 p-res-0 multi-select-styles">
      <ng-select [items]="result" [clearSearchOnAdd]="true" [closeOnSelect]="false" labelForId="state" [multiple]="true"
        [placeholder]="'orderHistorySearchForm.label.brand' | cxTranslate" clearAllText="Clear" formControlName="brand"
        [bindLabel]="'name'">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <div class="row">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
              [ngModelOptions]="{standalone: true}" />
              {{item['name']}}
            </div>
          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items">
            @for (item of items | slice:0:1; track item) {
              <div class="ng-value">
                {{item['name']}}
              </div>
            }
            @if (items.length > 1) {
              <div class="ng-value">
                <span class="ng-value-label">{{items.length - 1}} more...</span>
              </div>
            }
          </ng-template>
        </ng-select>

        <span class="highlight"></span>
        <label class="text-muted">{{ 'orderHistorySearchForm.label.brand' | cxTranslate }}<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
      </div>
      @if (FMC_Role; as items) {
        <div class="form-group col-lg-6 pl-0 float-left mb-3 mt-3 p-res-0 multi-select-styles">
          <ng-select [items]="items" [clearSearchOnAdd]="true" [closeOnSelect]="false" labelForId="state" [multiple]="true"
            [placeholder]="'KnbrProfile.label.role' | cxTranslate" clearAllText="Clear" formControlName="role"
            [bindLabel]="'name'">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="row">
                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                  [ngModelOptions]="{standalone: true}" />
                  {{item.split(":")[1]}}
                </div>
              </ng-template>
              <ng-template ng-multi-label-tmp let-items="items">
                @for (item of items | slice:0:1; track item) {
                  <div class="ng-value">
                    {{item.split(":")[1]}}
                  </div>
                }
                @if (items.length > 1) {
                  <div class="ng-value">
                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                  </div>
                }
              </ng-template>
            </ng-select>
            <span class="highlight"></span>
            <label class="text-muted">{{ 'KnbrProfile.label.role' | cxTranslate }}<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
          </div>
        }
        <div class="col-lg-12 p-0 float-left">
          <div class="col-lg-2 pl-0 p-res-0 float-left">
            <button type="submit" class="w-100 btn btn-primary" [disabled]="findMyContactSearchForm.invalid">
              {{ 'button.search' | cxTranslate }}
            </button>
          </div>
          <div class="col-lg-2 pl-0 p-res-0 float-left">
            <button type="button" (click)="resetForm()" class="w-100 btn btn-outline-primary">
              {{ 'button.reset' | cxTranslate }}
            </button>
          </div>
        </div>
      </form>
    </div>
